import { ITkFakeTableLineProps } from "../../type/componentsType/TkFakeTableLine";

const stepperData = ["内容入力", "入力内容確認", "機構へ提出"];

const fakeTableList: ITkFakeTableLineProps[] = [
  {
    title: "中小企業退職共済契約締結年月日",
    keyword: "contractDate",
    type: "text",
  },
  {
    title: "中小企業退職共済契約者番号",
    keyword: "contractNo",
    type: "text",
  },
  {
    title: "締結の理由",
    keyword: "contractReason",
    type: "text",
  },
  {
    title: "備考",
    keyword: "remark",
    type: "text",
  },
  {
    title: "従業状況は最新の状況になっていますか？",
    keyword: "employeeStatusCheckbox",
    type: "node",
  },
];

const schema = {};

export { stepperData, fakeTableList, schema };
